68
<template>
  <div v-if="technician" class="profile-container">
    <div class="profile-details">
      <div class="profile-image">
        <img
          :src="user.image || '/static/img/Male User.svg'"
          alt="Profile Picture"
        />
      </div>
      <div class="profile-info-container">
        <div class="profile-info">
          <div
            v-for="(cert, index) in formatCerts(technician.certs)"
            :key="index"
          >
            {{ cert }}
          </div>
        </div>
        <h1>{{ $global.getFullName(user) }}</h1>
      </div>
    </div>
    <div class="schedule-container">
      <div class="schedule-header">
        <div class="schedule-title">
          <!-- <img src="/static/img/brands/venture.svg" alt="">
          <span>Venture West Aviation</span> -->
        </div>
        <div class="schedule-actions">
          <button
            class="action-btn"
            @click="$router.push({ name: 'Schedule' })"
          >
            View Full Schedule
          </button>
          <!-- <button class="action-btn">Add to Google</button> to be implemented -->
        </div>
      </div>
      <div class="schedule-body">
        <h1>Maintenance Schedule</h1>
        <ScheduleCards :events="events" />
      </div>
      <div class="table-container mt-4">
        <table class="table table-bordered">
          <thead>
            <tr class="text-center">
              <th>Aircraft</th>
              <th>Reporter</th>
              <th>Date</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(request, index) in approvedSquawks" :key="index">
              <td>{{ request?.aircraft?.tailNumber }}</td>
              <td>
                {{
                  `${request?.creationUser?.firstName} ${request?.creationUser?.lastName}`
                }}
              </td>
              <td>{{ $global.formatDate(request.creationDate) }}</td>
              <td>{{ request.squawkStatus?.name }}</td>
              <td>
                <span @click="showSquawk(request)">Open Squawk</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="text-center text-secondary font-italic">
          <span v-if="loading">Loading..</span>
          <span v-if="!filteredRequests.length && !loading">No Data</span>
        </div>
      </div>
    </div>

    <AddSquawk
      @close="closeSquawk"
      @save="saveSquawk"
      placement="Centered"
      :onOutsideClick="closeSquawk"
      :status="squawksStatus"
      :modalData="modalData"
      :isView="false"
      :isEdit="true"
      :isvisible="isVisible"
    />
  </div>
</template>
<script>
import { useLoginStore } from "@/stores/loginStore";
import SquawksAPIService from "../../../servicehandlers/SquawksAPIService";
import EventsAPIService from "@/servicehandlers/EventsAPIService";
import ScheduleCards from "./ScheduleCards.vue";
import AddSquawk from "./Aircraft/AddSquawk.vue";
import dayjs from "dayjs";
const squawksAPIService = new SquawksAPIService();
const eventsAPIService = new EventsAPIService();
export default {
  components: {
    ScheduleCards,
    AddSquawk,
  },
  computed: {
    cssVars() {
      return {
        "--timeLoc": 35 + this.timeOffset() + "px",
      };
    },
    approvedSquawks() {
      return this.filteredRequests.filter((request) => {
        return request.approvalDate;
      });
    },
  },
  data() {
    return {
      user: null,
      technician: null,
      profilePicPath: null,
      rightLogoPath: null,
      timeCard: null,
      payroll: null,
      upcomingSchedule: [],
      filteredRequests: [],
      allRequests: [],
      displayAmount: 10,
      loading: false,
      isVisible: false,
      squawksStatus: [],
      modalData: {},
      events: [],
    };
  },
  async mounted() {
    await this.commonRequests();
  },
  methods: {
    async commonRequests() {
      this.getSquawksStatus();
      this.getTechnician();
      this.getTimeCard();
      this.getPayroll();
      this.getUpcomingSchedule();
      this.getEvents();
      this.getRequests();
    },
    async getEvents() {
      const startDateTime = dayjs().add(1, "days").startOf("day");
      const endDateTime = dayjs(startDateTime).add(4, "days").endOf("day");
      const params = {
        startDateTime: startDateTime.toISOString(),
        endDateTime: endDateTime.toISOString(),
      };

      try {
        this.events = await eventsAPIService.getMaintenanceEvents(
          this.$store.getUser.id,
          params,
          this.$router,
        );
      } catch (error) {}
    },
    getUpcomingSchedule() {
      this.upcomingSchedule = Array.from({ length: 5 }, (_, index) => {
        const date = dayjs().add(index, "day").toDate();
        return {
          id: index + 1,
          today: index === 0,
          date,
          schedule: [],
        };
      });

      this.events.forEach((event) => {
        const eventDate = dayjs(event.startDateTime).startOf("day");
        const daySchedule = this.upcomingSchedule.find((day) =>
          dayjs(day.date).isSame(eventDate, "day"),
        );

        if (daySchedule) {
          const startTime = dayjs(event.startDateTime);
          const endTime = dayjs(event.endDateTime);

          const startPeriod = startTime.format("A");
          const endPeriod = endTime.format("A");

          const startDisplayTime =
            startPeriod === endPeriod
              ? startTime.format("h:mm")
              : startTime.format("h:mm A");

          const endDisplayTime = endTime.format("h:mm A");
          daySchedule.schedule.push({
            startTime,
            startDisplayTime,
            endTime,
            endDisplayTime,
            name: event.eventType ? event.eventType.name : "Maintenance",
          });
        }
      });

      this.upcomingSchedule.forEach((day) => {
        day.schedule.sort((a, b) =>
          a.startTime.isBefore(b.startTime) ? -1 : 1,
        );
      });
    },
    async saveSquawk() {
      this.isVisible = false;
      await this.commonRequests();
    },
    showSquawk(request) {
      // this.$router.push({ name: `Aircraft Details`, params: { aircraft: request.aircraft } });
      this.isVisible = true;
      this.modalData = { ...request, squawk: request };
    },
    closeSquawk() {
      this.isVisible = false;
      this.modalData = {};
    },
    async getSquawksStatus() {
      try {
        this.squawksStatus = await squawksAPIService.getStatuses(this.$router);
      } catch (error) {}
    },
    formatCerts(certs) {
      if (!certs) return [];
      const certArray = certs.split(",").map((cert) => cert.trim());
      if (certArray.length <= 1) return certArray;
      return certArray.reduce((acc, cert, i) => {
        if (i === certArray.length - 1) return [...acc, cert];
        return [...acc, cert, "|"];
      }, []);
    },
    getTechnician() {
      const store = useLoginStore();
      const user = store.getUser;
      this.user = user;

      const certAcronyms =
        user.userTechnicianCerts?.map((cert) => cert.technicianCert.acronym) ||
        [];

      this.technician = {
        ...user,
        certs: certAcronyms.join(", "),
        balance: 1200,
      };
      this.getProfilePic();
    },
    getId() {
      // TODO this.route.params only exists when admin clicking on a user profile, need to debug when thats not the case
      //return this.$route.params.id ? this.$route.params.id : this.user.id;
      return this.user.id;
    },
    getIdType() {
      //return this.$route.params.id ? "maintenance" : "userId";
      return "maintenance";
    },
    getProfilePic() {
      this.profilePicPath = "/static/img/faces/face-0.jpg";
      this.rightLogoPath = "/static/img/m-x-technician-logo.png";
    },
    getTimeCard() {
      this.timeCard = {
        hoursWorked: 45.0,
        hoursScheduled: 40.0,
        overTimeApproved: 0,
      };
    },
    getPayroll() {
      this.payroll = {
        paymentDate: new Date("04/20/2024"),
        amount: 1200,
        periodStart: new Date("04/01/2024"),
        periodEnd: new Date("04/15/2024"),
      };
    },
    getRequests() {
      return squawksAPIService.get(this.$router).then((response) => {
        response = response.reverse();
        for (let item of response) {
          if (
            item.aircraft &&
            item.descriptionDate &&
            item.reporterName &&
            item.squawkStatus
          ) {
            item.airplane = item.aircraft?.tailNumber;
            item.descriptionDate = new Date(
              item.descriptionDate,
            ).toLocaleDateString("en-US", {
              month: "2-digit",
              day: "2-digit",
              year: "numeric",
            });
            item.reporterName =
              item.descriptionUser.firstName +
              " " +
              item.descriptionUser.lastName;
            item.status = item.squawkStatus.name;
          }
        }
        this.allRequests = response.filter((data) => !data.responseUserId);

        this.updateDisplayedRequests(0);
      });
    },
    goToDocuments() {
      alert("Went to documents page!");
    },
    currentTimeDateString() {
      let today = new Date();
      let hours = today.getHours();
      let ampm;
      if (hours >= 0 && hours < 12) {
        ampm = "am";
      } else {
        ampm = "pm";
        hours -= 12;
      }
      if (hours === 0) hours = 12;
      let minutes = today.getMinutes();
      minutes = 0 + JSON.stringify(minutes);
      minutes = minutes.slice(-2);
      return hours + ":" + minutes + ampm + ", " + today.toLocaleDateString();
    },
    timeOffset() {
      let first = 0;
      let last = 20;
      let today = new Date();
      let hours = today.getHours() + today.getMinutes() / 60;
      for (let item of this.upcomingSchedule[0].schedule) {
        let temp = item;
        if (item.startM === "PM") {
          if (temp.startTime !== 12) {
            temp.startTime = temp.startTime + 12;
          }
        }
        if (item.endM === "PM") {
          if (temp.endTime !== 12) {
            temp.endTime = temp.endTime + 12;
          }
        }
        if (temp.startTime > hours) break;
        if (temp.startTime <= hours && temp.endTime >= hours) {
          let amount =
            (hours - temp.startTime) / (temp.endTime - temp.startTime);
          amount = Math.floor(amount * last) + first;
          if (item.startM === "PM") {
            temp.startTime = temp.startTime - 12;
          }
          if (item.endM === "PM") {
            temp.endTime = temp.endTime - 12;
          }
          return amount;
        } else {
          first += last;
        }
        if (item.startM === "PM") {
          temp.startTime = temp.startTime - 12;
        }
        if (item.endM === "PM") {
          temp.endTime = temp.endTime - 12;
        }
      }
      return first;
    },
    skipToStart() {
      this.updateDisplayedRequests(0);
    },
    skipToEnd() {
      let lastLoc =
        Math.floor(this.allRequests.length / parseInt(this.displayAmount)) *
        parseInt(this.displayAmount);
      if (lastLoc === this.allRequests.length) {
        lastLoc -= parseInt(this.displayAmount);
      }
      this.updateDisplayedRequests(lastLoc);
    },
    nextGroup() {
      let index = this.allRequests.indexOf(
        this.filteredRequests[this.filteredRequests.length - 1],
      );
      if (index >= this.allRequests.length - 1) {
        this.skipToStart();
      } else {
        this.updateDisplayedRequests(index + 1);
      }
    },
    lastGroup() {
      let index = this.allRequests.indexOf(this.filteredRequests[0]);
      index -= parseInt(this.displayAmount);
      if (index < 0) {
        this.skipToEnd();
      } else {
        this.updateDisplayedRequests(index);
      }
    },
    changeDisplayAmount() {
      let index = this.allRequests.indexOf(this.filteredRequests[0]);
      this.updateDisplayedRequests(index);
    },
    updateDisplayedRequests(start) {
      this.filteredRequests = [];
      for (let i = start; i < start + parseInt(this.displayAmount); i++) {
        if (i >= this.allRequests.length) break;
        this.filteredRequests.push(this.allRequests[i]);
      }
    },
    findFirstLoc() {
      let index = this.allRequests.indexOf(this.filteredRequests[0]);
      return index + 1;
    },
    findLastLoc() {
      let index = this.allRequests.indexOf(
        this.filteredRequests[this.filteredRequests.length - 1],
      );
      return index + 1;
    },
    goToSquawks(id, tailNumber) {
      this.$router.push({
        path: `/hilo/aircraft/${tailNumber}/squawk`,
        query: {
          type: "update",
          id: id,
        },
      });
    },
  },
};
</script>
<style scoped>
.profile-container {
  display: flex;
  flex-direction: column;
  gap: 50px;
  padding: 20px 40px;
}

.profile-details {
  display: flex;
  align-items: center;
  gap: 40px;
}

.profile-image {
  width: 140px;
  height: 140px;
  z-index: 2;
  position: relative;
}

.profile-image img {
  width: 140px;
  height: 140px;
  border-radius: 20px;
  position: absolute;
  z-index: 2;
  background: #fff;
  border: 2px solid #fff;
}

.profile-image::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50px;
  height: 70px;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 10px;
  z-index: 1;
}

.profile-info-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
}

.profile-info-container h1,
.schedule-body h1 {
  font-size: 50px;
  font-weight: bold;
  color: #404040;
  line-height: 30px;
}

.schedule-body h1 {
  line-height: normal;
}

.profile-info {
  display: flex;
  gap: 15px;
}

.profile-info div {
  font-size: 18px;
  font-weight: 500;
  color: #000;
}

.schedule-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.schedule-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.schedule-title {
  display: flex;
  gap: 10px;
  align-items: center;
}

.schedule-title img {
  width: 25px;
  height: 25px;
  border-radius: 5px;
  margin-left: 30px;
}

.schedule-title span {
  font-size: 14px;
  font-weight: bold;
  color: #404040;
}

.schedule-actions {
  display: flex;
  gap: 8px;
}

.schedule-actions .action-btn {
  padding: 4px 25px;
  border-radius: 5px;
  color: #404040;
  background: #c8c8c8;
  font-weight: normal;
}

.schedule-body {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.table-container table {
  box-shadow: 0 0 15px 0 #ccc;
}

.table-container table thead {
  text-align: center;
  background: #707070;
  border-top-left-radius: 15px !important;
  border-top-right-radius: 15px !important;
}

.table-container table tbody tr {
  text-align: center;
}

.table-container table th {
  color: white;
  font-size: 16px;
  font-weight: 500;
  text-transform: lowercase !important;
  text-transform: capitalize !important;
}

.table-container table thead th:first-child {
  border-top-left-radius: 15px !important;
}

.table-container table thead th:last-child {
  border-top-right-radius: 15px !important;
}

.table-container table td {
  border: 1px solid #ccc;
}

.table-container table td span {
  color: #3171e2;
  cursor: pointer;
}
</style>
